import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user clicks "Download vtt" or "Download srt" option',
  name: 'downloaded_transcript',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of file downloaded',
      name: 'file_type',
      required: true,
      type: 'enum',
      values: ['vtt', 'srt', 'txt'],
    },
  ],
};

export default META;
